import createReactClass from "create-react-class";
import React from "react";
import { Button, ControlLabel } from "react-bootstrap";
import { ServerActions } from "../actions/serverActions";
import { compareDetailsStore } from "../stores/compareDetails";
import { runCompareStore } from "../stores/runCompareStore";
import { subdivisionStore } from "../stores/subdivision";

function getStateFromStores() {
  return {
    itemListOpened: compareDetailsStore.getListOpened(),
    itemDetailOpened: compareDetailsStore.getDetailsOpened(),
    messageSuccess: compareDetailsStore.getMessageSuccess(),
    divHeight: runCompareStore.getHeight(),
    selectableSubList: subdivisionStore.getSubList(),
    selectedSub: [],
    textContent: "",
  };
}

export const SubdivisionRecalculate = createReactClass({
  componentDidMount: function () {
    $("#mainSchematic").empty();
    compareDetailsStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    ServerActions.getSubdivisionList();
    ServerActions.startOutageStateCheck();
    ServerActions.getUserRole();
  },

  componentWillUnmount: function () {
    compareDetailsStore.unsubscribe(this._onChange);
    runCompareStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  deleteSub: function (e) {
    console.log(e.target.id);
    var index = e.target.id;
    var selectedSubdivision = [];
    this.state.selectedSub.map(function (sub, i) {
      if (i != index) {
        selectedSubdivision.push(sub);
      }
    });
    this.setState({ selectedSub: selectedSubdivision });
  },
  onChange: function (e) {
    var value = e.target.value.toUpperCase();
    this.setState({ textContent: value });
  },

  onSubSelectChange: function (event) {
    this.setState({ messageSuccess: "" });
    var val = event.target.value;
    var selectedSubdivision = this.state.selectedSub;
    if (selectedSubdivision.indexOf(val) > -1 || val == 0) {
      return;
    } else {
      selectedSubdivision.push(val);
      var textVal = this.state.textContent + "," + val;
      this.setState({ textContent: textVal });
      this.setState({ selectedSub: selectedSubdivision });
    }
  },
  sendRequest: function () {
    if (this.state.selectedSub.length > 0) {
      ServerActions.calculateSubdivision(this.state.selectedSub);
      this.setState({ messageSuccess: "Please Wait..Recalculating subs" });
    } else {
      this.setState({ messageSuccess: "Please select a subdivision" });
    }
  },

  renderChip: function () {
    var selectedValues;

    selectedValues = this.state.selectedSub.map(
      function (sub, i) {
        return (
          <span key={sub} style={{ backgroundColor: "white", padding: "2px" }}>
            {" "}
            {sub}{" "}
            <i
              key={i}
              id={i}
              style={{ color: "red", cursor: "pointer" }}
              onClick={this.deleteSub}
            >
              X
            </i>
          </span>
        );
      }.bind(this)
    );
    return selectedValues;
  },
  render: function () {
    //var ht =91;
    var subdivisions = [];
    var disableSubSelector = false;
    var selectText = "Select...";
    if (this.state.selectableSubList) {
      subdivisions = this.state.selectableSubList.map(function (sub, i) {
        return (
          <option key={i + 1} value={sub.name}>
            {sub.name}
          </option>
        );
      });

      subdivisions.splice(
        0,
        0,
        <option key={0} value="0">
          {selectText}
        </option>
      );
    }

    var renderChip = this.renderChip();

    return (
      <div
        id="recalcSubdivPanel"
        style={{ height: "92%", backgroundColor: "#b0c4de" }}
      >
        <div id="divContainer">
          <ControlLabel style={{ color: "black" }}>
            Please choose one or more subdivisions:
          </ControlLabel>{" "}
          <select
            id="subdivisionSelect"
            disabled={disableSubSelector}
            onChange={this.onSubSelectChange}
          >
            {subdivisions}
          </select>
          <div>
            <ControlLabel style={{ color: "black" }}>
              Selected Sub's:
            </ControlLabel>
          </div>
          {renderChip}
          <div>
            <h4>{this.state.messageSuccess}</h4>
          </div>
          <Button type="button" bsStyle="primary" onClick={this.sendRequest}>
            Recalculate Subdivision
          </Button>
        </div>
      </div>
    );
  },
});
